<template>
  <div>
    <h5>Eingabekriterien</h5>
    <div class="error-message">
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
        :property-mapping="errorPropertyMappings"
      />
    </div>
    <u-loader v-if="isLoading" />
    <div
      v-else
      class="col-12"
    >
      <div
        v-for="(criteria, index) in items"
        :key="index"
        class="configurationWrapper w-100"
      >
        <div
          class="criterionTitle position-relative"
          @click="
            expandedId != criteria.id
              ? (expandedId = criteria.id)
              : (expandedId = -1);
            RangeErrorObject = null;
            ListerrorObject = null;
          "
        >
          <i
            v-if="criteria.type == 1"
            v-b-tooltip.hover
            class="fa fa-list mr-4 width20"
            placement="bottom"
            title="Liste"
          />
          <i
            v-if="criteria.type == 4"
            v-b-tooltip.hover
            class="fas fa-sort-amount-down mr-4 width20"
            placement="bottom"
            title="Abhängige Liste"
          />
          <i
            v-if="criteria.type == 2"
            v-b-tooltip.hover
            class="fa fa-arrows-alt-h mr-4 width20"
            placement="bottom"
            title="Bereich"
          />
          <i
            v-if="criteria.type == 3"
            v-b-tooltip.hover
            class="fa fa-digital-tachograph mr-4 width20"
            placement="bottom"
            title="Dynamischer Bereich"
          />
          <i
            v-if="criteria.type == 6"
            v-b-tooltip.hover
            class="fa fa-map-marker mr-4 width20"
            placement="bottom"
            title="Kantonsliste"
          />
          <i
            v-if="criteria.type == 9"
            v-b-tooltip.hover
            class="fa fa-map-marker mr-4 width20"
            placement="bottom"
            title="Abhängig von Kantonsliste"
          />
          <i
            v-if="criteria.type == 7"
            v-b-tooltip.hover
            class="fa fa-map-marker mr-4 width20"
            placement="bottom"
            title="Bezirksliste"
          />
          <i
            v-if="criteria.type == 10"
            v-b-tooltip.hover
            class="fa fa-map-marker mr-4 width20"
            placement="bottom"
            title="Abhängig von BezirksListe"
          />
          <i
            v-if="criteria.type == 8"
            v-b-tooltip.hover
            class="fa fa-map-marker mr-4 width20"
            placement="bottom"
            title="Postleitzahlliste"
          />
          <i
            v-if="criteria.type == 11"
            v-b-tooltip.hover
            class="fa fa-map-marker mr-4 width20"
            placement="bottom"
            title="Abhängig von Postleitzahlliste"
          />
          <i
            v-if="criteria.type == 12"
            v-b-tooltip.hover
            class="fa fa-layer-group mr-4 width20"
            placement="bottom"
            title="Gruppierte PLZ"
          />
          <span>{{ criteria.title }}</span>
          <button
            v-if="canUserEdit"
            v-b-modal.confirmDeleteListItem
            v-b-tooltip.hover
            class="btn btn-danger deleteCriteriaButton"
            placement="bottom"
            title="Dieses Eingabekriterium löschen"
            type="button"
            @click="criteriaToDelteIndex = index"
          >
            <i class="fas fa-trash-alt" />
          </button>
        </div>
        <div
          v-if="criteria.id == expandedId"
          class="criteriaContent"
          style=""
        >
          <form class="my-4 mx-3">
            <div class="row">
              <div class="col-12">
                <u-help-text
                  class="float-right"
                  help-id="inputCriteriaHelp"
                  help-title="Information"
                >
                  <p>
                    <b>Liste: </b>Eine einfache Liste mit einer beliebigen
                    Anzahl an Werten
                  </p>
                  <p>
                    <b>Bereich: </b>Durch zwei Zahlen abgegrenzter Bereich von
                    möglichen Werten
                  </p>
                  <p>
                    <b>Abhängige Liste: </b>Eine Liste, deren Werte jedoch nur
                    zutreffen wenn die definierten Filter zutreffen. Es müssen
                    alle Filter zutreffen (AND)
                  </p>
                  <p>
                    <b>Dynamischer Bereich: </b>Siehe Bereich, jedoch können
                    hier auch einfache Formeln und andere Bereiche verwendet
                    werden, z.b. "100 - Bereich1"
                  </p>
                  <p>
                    <b>Kanton-, Bezirk-, Postleihzahlliste: </b>Auswahlstruktur
                    für ortsbasierte Einträge. Es können nur Orte innerhalb des
                    Geltungsbereichs des Vertrags gewählt werden.
                  </p>
                  <p>
                    <b>Abhängig von Kanton-, Bezirk-, Postleihzahlliste: </b>Liste, deren Werte nur zutreffen, wenn einer der
                    definierten Orte gewählt wurde. (OR)
                  </p>
                </u-help-text>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label class="font-weight-bold mt-3">Zielkriterium</label>
              </div>
              <div class="col-10">
                <v-select
                  v-model="criteria.criteriaStructureId"
                  :disabled="!canUserEdit"
                  :items="$store.state.mindestLohnKonfiguration.StructureFlat"
                  item-text="name"
                  item-value="id"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label class="font-weight-bold mt-3">Titel</label>
              </div>
              <div class="col-10">
                <v-text-field
                  v-model="criteria.title"
                  :disabled="!canUserEdit"
                  label="Titel"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label class="font-weight-bold mt-3">Typ</label>
              </div>
              <div class="col-10">
                <v-select
                  v-model="criteria.type"
                  :disabled="!canUserEdit"
                  :items="criteriaTypes"
                  item-text="name"
                  item-value="id"
                  @change="criteriaTypeChanged"
                />
              </div>
            </div>
            <div v-if="criteria.type == 1">
              <u-error-handling
                v-if="ListerrorObject"
                :error-object="ListerrorObject"
                :property-mapping="listErrorPropertyMappings"
                class="col-12 mt-4"
              />
              <criteria-list
                v-model="criteria.listEntries"
                :criterias="items"
                :qualification-levels="qualificationLevels"
                @save="saveCriteria(criteria)"
                @import="handleImportListItem($event, criteria)"
                @cancel="getCriteria()"
              />
            </div>
            <div
              v-if="criteria.type == 2"
              class="row"
            >
              <div class="col-2">
                <label class="font-weight-bold my-3">Bereich</label>
              </div>
              <div class="col-10">
                <div class="row mt-4">
                  <span class="col-1 verticalAlignCenter">Von</span>
                  <v-text-field
                    v-model="criteria.range.from"
                    :disabled="!canUserEdit"
                    class="col-11"
                    label="Von"
                    type="number"
                  />
                  <span class="col-1 verticalAlignCenter">Bis</span>
                  <v-text-field
                    v-model="criteria.range.to"
                    :disabled="!canUserEdit"
                    class="col-11"
                    label="Bis"
                    type="number"
                  />
                </div>
              </div>
              <u-error-handling
                v-if="RangeErrorObject"
                :error-object="RangeErrorObject"
                :property-mapping="rangeErrorPropertyMappings"
                class="col-12 mt-4"
              />
              <b-button
                v-if="canUserEdit"
                class="mt-2"
                name="saveStrucuture"
                variant="success"
                @click="saveCriteria(criteria)"
              >
                Speichern
              </b-button>
              <b-button
                v-if="canUserEdit"
                class="mt-2 ml-2"
                name="loadStructure"
                variant="danger"
                @click="getCriteria()"
              >
                Abbrechen
              </b-button>
            </div>
            <div
              v-if="criteria.type == 4"
              class="row"
            >
              <u-error-handling
                v-if="ListerrorObject"
                :error-object="ListerrorObject"
                :property-mapping="listErrorPropertyMappings"
                class="col-12 mt-4"
              />
              <div class="col-12">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Filter
                </label>
              </div>
              <div
                v-for="(
                  filterGroup, filterGroupIndex
                ) in criteria.criteriaGroupFilters"
                :key="filterGroupIndex"
                class="w-100"
              >
                <div class="grouped-filters">
                  <div class="group-title">
                    AND-Gruppe
                  </div>
                  <button
                    v-if="canUserEdit"
                    v-b-tooltip.hover
                    class="btn btn-danger actionButton mt-2 ml-4"
                    placement="bottom"
                    title="And-Gruppe löschen"
                    type="button"
                    @click="
                      deleteFilterGroup(
                        criteria.criteriaGroupFilters,
                        filterGroupIndex,
                      )
                    "
                  >
                    <i class="fas fa-trash-alt" />
                  </button>
                  <div
                    v-for="(filter, filterIndex) in filterGroup.filters"
                    :key="filter.id + '_' + filterIndex"
                    class="col-12 d-flex"
                  >
                    <criteria-groups-filter
                      v-model="filterGroup.filters[filterIndex]"
                      :contract-id="contractId"
                      :edition-id="editionId"
                      :readonly="!canUserEdit"
                      :version-id="versionId"
                      class="col-12"
                    />
                    <div>
                      <button
                        v-if="canUserEdit"
                        v-b-tooltip.hover
                        class="btn btn-danger deleteFilterActionButton"
                        placement="bottom"
                        title="Diesen Filter löschen"
                        type="button"
                        @click="
                          removeListItem(filterGroup.filters, filterIndex)
                        "
                      >
                        <i class="fas fa-trash-alt" />
                      </button>
                    </div>
                  </div>
                  <button
                    v-if="canUserEdit"
                    v-b-tooltip.hover
                    class="btn btn-success smallActionButton mt-2 ml-4"
                    placement="bottom"
                    title="Neuer Filter hinzufügen"
                    type="button"
                    @click="addNewFilterItem(filterGroup.filters)"
                  >
                    <i class="fas fa-plus" />
                  </button>
                </div>
                <div
                  v-if="
                    filterGroupIndex + 1 < criteria.criteriaGroupFilters.length
                  "
                  class="or-label my-4 d-flex"
                >
                  OR
                </div>
              </div>

              <div class="w-100">
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn d-block btn-success float-right actionButton mr-4"
                  placement="bottom"
                  title="weitere AND-Gruppe hinzufügen"
                  type="button"
                  @click="addNewFilterGroup(criteria)"
                >
                  <i class="fas fa-plus" />
                </button>
                <criteria-add-localised-or-values
                  class="actionButton"
                  :contract-id="contractId"
                  :edition-id="editionId"
                  :version-id="versionId"
                  @added="handleAddLocalisedOrValues($event, criteria)"
                  @opened="criteriaToAddOrCandidatesIndex = index"
                />
              </div>
              <div class="col-12">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste
                </label>
              </div>
              <div
                v-for="(listItem, listItemIndex) in criteria.listEntries"
                :key="listItem.order + '_' + listItemIndex"
                class="col-12 d-flex"
              >
                <v-text-field
                  v-model="listItem.order"
                  :disabled="!canUserEdit"
                  class="col-1"
                  label="Sortierung"
                  type="number"
                >
                  <template
                    v-if="
                      criteria.listEntries.filter((item) => {
                        return item.order == listItem.order;
                      }).length > 1
                    "
                    slot="append"
                  >
                    <i
                      class="small"
                      style="color: red"
                    >Doppelte Sortierung</i>
                  </template>
                </v-text-field>
                <u-multiline-multilanguage-text-input
                  :id="'listItemValueInput' + listItemIndex"
                  v-model="listItem.contents"
                  :is-multiline="true"
                  :readonly="!canUserEdit"
                  content-property-name="text"
                />
                <v-select
                  v-if="
                    $store.state.mindestLohnKonfiguration.Configuration
                      .qualificationLevelEnabled
                  "
                  v-model="listItem.qualificationLevel"
                  :disabled="!canUserEdit"
                  :items="qualificationLevels"
                  class="ml-2"
                  placeholder="Qualifikationsstufe"
                  style="min-width: 316px"
                  text="text"
                  value="value"
                />
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-danger float-right actionButton"
                  placement="bottom"
                  title="Diesen Listeneintrag löschen"
                  type="button"
                  @click="removeListItem(criteria.listEntries, listItemIndex)"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
            </div>
            <div
              v-if="criteria.type == 4"
              class="row justify-content-end"
            >
              <div class="col-3">
                <v-select
                  v-model="criteriaToImportId"
                  :items="items"
                  item-text="title"
                  item-value="id"
                  label="Listeneintrag"
                />
              </div>

              <div>
                <b-button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="mt-2"
                  title="Listeneintrag impotieren"
                  variant="success"
                  @click="importListItem(criteria.listEntries)"
                >
                  <i class="fas fa-solid fa-file-import" />
                </b-button>
              </div>

              <div class="col-auto">
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-success actionButton mt-2"
                  title="Neuen Listeneintrag erfassen"
                  type="button"
                  @click="addNewListItem(criteria.listEntries)"
                >
                  <i class="fas fa-plus" />
                </button>
              </div>
            </div>
            <div
              v-if="criteria.type == 4"
              class="row"
            >
              <b-button
                v-if="canUserEdit"
                :disabled="
                  new Set(criteria.listEntries.map((a) => a.order.toString()))
                    .size < criteria.listEntries.length
                "
                class="mt-2"
                name="saveStrucuture"
                variant="success"
                @click="saveCriteria(criteria)"
              >
                Speichern
              </b-button>
              <b-button
                v-if="canUserEdit"
                class="mt-2 ml-2"
                name="loadStructure"
                variant="danger"
                @click="getCriteria()"
              >
                Abbrechen
              </b-button>
            </div>
            <div
              v-if="criteria.type == 3"
              class="row"
            >
              <div class="col-2">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Bereich
                </label>
              </div>
              <div class="col-10">
                <div class="row mt-4">
                  <span class="col-1 verticalAlignCenter">Von</span>
                  <v-text-field
                    v-model="criteria.range.from"
                    :disabled="!canUserEdit"
                    class="col-11"
                    label="Von"
                  />
                  <span class="col-1 verticalAlignCenter">Bis</span>
                  <v-text-field
                    v-model="criteria.range.to"
                    :disabled="!canUserEdit"
                    class="col-11"
                    label="Bis"
                  />
                </div>
              </div>
              <u-error-handling
                v-if="ListerrorObject"
                :error-object="ListerrorObject"
                :property-mapping="listErrorPropertyMappings"
                class="col-12 mt-4"
              />
              <b-button
                v-if="canUserEdit"
                class="mt-2"
                name="saveStrucuture"
                variant="success"
                @click="saveCriteria(criteria)"
              >
                Speichern
              </b-button>
              <b-button
                v-if="canUserEdit"
                class="mt-2 ml-2"
                name="loadStructure"
                variant="danger"
                @click="getCriteria()"
              >
                Abbrechen
              </b-button>
            </div>
            <div
              v-if="criteria.type == 6"
              class="row"
            >
              <div class="col-2">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste der Kantone
                </label>
              </div>
              <div class="col-10">
                <u-tree-view
                  v-if="!isLoading"
                  id="cantonTree"
                  v-model="criteria.criteriaPlzs"
                  :disabled="false"
                  :selectable="false"
                  :tree-view-items="cantonOptions"
                  item-key="path"
                >
                  <template v-slot:prepend="{ item }">
                    <div @click="togglePlzNode(item, index)">
                      <i
                        :class="getIcon(item, index)"
                        :style="{ scale: '1.8', color: getColor(item, index) }"
                      />
                    </div>
                  </template>
                </u-tree-view>
              </div>
            </div>
            <div
              v-if="criteria.type == 7"
              class="row"
            >
              <div class="col-2">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste der Bezirke
                </label>
              </div>
              <div class="col-10">
                <u-tree-view
                  v-if="!isLoading"
                  id="districtTree"
                  v-model="criteria.criteriaPlzs"
                  :disabled="false"
                  :selectable="false"
                  :tree-view-items="districtOptions"
                  item-key="path"
                >
                  <template v-slot:prepend="{ item }">
                    <div @click="togglePlzNode(item, index)">
                      <i
                        :class="getIcon(item, index)"
                        :style="{ scale: '1.8', color: getColor(item, index) }"
                      />
                    </div>
                  </template>
                </u-tree-view>
              </div>
            </div>
            <div
              v-if="criteria.type == 8"
              class="row"
            >
              <div class="col-2">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste der PLZ
                </label>
              </div>
              <div class="col-10">
                <u-tree-view
                  v-if="!isLoading"
                  id="cityTree"
                  v-model="criteria.criteriaPlzs"
                  :disabled="false"
                  :selectable="false"
                  :tree-view-items="citiesOptions"
                  item-key="path"
                >
                  <template v-slot:prepend="{ item }">
                    <div @click="togglePlzNode(item, index)">
                      <i
                        :class="getIcon(item, index)"
                        :style="{ scale: '1.8', color: getColor(item, index) }"
                      />
                    </div>
                  </template>
                </u-tree-view>
              </div>
            </div>
            <div
              v-if="criteria.type == 9"
              class="row"
            >
              <div class="col-2">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste der Kantone
                </label>
              </div>
              <div class="col-10">
                <u-tree-view
                  v-if="!isLoading"
                  id="cantonDepTree"
                  v-model="criteria.criteriaPlzs"
                  :disabled="false"
                  :selectable="false"
                  :tree-view-items="
                    getTreeOptionsOfCriteria(criteria, cantonOptions)
                  "
                  item-key="path"
                >
                  <template v-slot:prepend="{ item }">
                    <div @click="togglePlzNode(item, index)">
                      <i
                        :class="getIcon(item, index)"
                        :style="{ scale: '1.8', color: getColor(item, index) }"
                      />
                    </div>
                  </template>
                </u-tree-view>
              </div>
            </div>
            <div
              v-if="criteria.type == 9"
              class="row"
            >
              <div class="col-12">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste
                </label>
              </div>
              <div
                v-for="(listItem, listItemIndex) in criteria.listEntries"
                :key="listItem.order + '_' + listItemIndex"
                class="col-12 d-flex"
              >
                <v-text-field
                  v-model="listItem.order"
                  :disabled="!canUserEdit"
                  class="col-1"
                  label="Sortierung"
                  type="number"
                >
                  <template
                    v-if="
                      criteria.listEntries.filter((item) => {
                        return item.order == listItem.order;
                      }).length > 1
                    "
                    slot="append"
                  >
                    <i
                      class="small"
                      style="color: red"
                    >Doppelte Sortierung</i>
                  </template>
                </v-text-field>
                <u-multiline-multilanguage-text-input
                  :id="'listItemValueInput' + listItemIndex"
                  v-model="listItem.contents"
                  :is-multiline="true"
                  :readonly="!canUserEdit"
                  content-property-name="text"
                />
                <v-select
                  v-if="
                    $store.state.mindestLohnKonfiguration.Configuration
                      .qualificationLevelEnabled
                  "
                  v-model="listItem.qualificationLevel"
                  :disabled="!canUserEdit"
                  :items="qualificationLevels"
                  class="ml-2"
                  placeholder="Qualifikationsstufe"
                  style="min-width: 316px"
                  text="text"
                  value="value"
                />
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-danger float-right actionButton"
                  placement="bottom"
                  title="Diesen Listeneintrag löschen"
                  type="button"
                  @click="removeListItem(criteria.listEntries, listItemIndex)"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
            </div>
            <div
              v-if="criteria.type == 9"
              class="row justify-content-end"
            >
              <div class="col-3">
                <v-select
                  v-model="criteriaToImportId"
                  :items="items"
                  item-text="title"
                  item-value="id"
                  label="Listeneintrag"
                />
              </div>

              <div>
                <b-button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="mt-2"
                  title="Listeneintrag impotieren"
                  variant="success"
                  @click="importListItem(criteria.listEntries)"
                >
                  <i class="fas fa-solid fa-file-import" />
                </b-button>
              </div>

              <div class="col-auto">
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-success actionButton mt-2"
                  title="Neuen Listeneintrag erfassen"
                  type="button"
                  @click="addNewListItem(criteria.listEntries)"
                >
                  <i class="fas fa-plus" />
                </button>
              </div>
            </div>
            <div
              v-if="criteria.type == 10"
              class="row"
            >
              <div class="col-2">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste der Bezirke
                </label>
              </div>
              <div class="col-10">
                <u-tree-view
                  v-if="!isLoading"
                  id="districtDepTree"
                  v-model="criteria.criteriaPlzs"
                  :disabled="false"
                  :selectable="false"
                  :tree-view-items="
                    getTreeOptionsOfCriteria(criteria, districtOptions)
                  "
                  item-key="path"
                >
                  <template v-slot:prepend="{ item }">
                    <div @click="togglePlzNode(item, index)">
                      <i
                        :class="getIcon(item, index)"
                        :style="{ scale: '1.8', color: getColor(item, index) }"
                      />
                    </div>
                  </template>
                </u-tree-view>
              </div>
            </div>
            <div
              v-if="criteria.type == 10"
              class="row"
            >
              <div class="col-12">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste
                </label>
              </div>
              <div
                v-for="(listItem, listItemIndex) in criteria.listEntries"
                :key="listItem.order + '_' + listItemIndex"
                class="col-12 d-flex"
              >
                <v-text-field
                  v-model="listItem.order"
                  :disabled="!canUserEdit"
                  class="col-1"
                  label="Sortierung"
                  type="number"
                >
                  <template
                    v-if="
                      criteria.listEntries.filter((item) => {
                        return item.order == listItem.order;
                      }).length > 1
                    "
                    slot="append"
                  >
                    <i
                      class="small"
                      style="color: red"
                    >Doppelte Sortierung</i>
                  </template>
                </v-text-field>
                <u-multiline-multilanguage-text-input
                  :id="'listItemValueInput' + listItemIndex"
                  v-model="listItem.contents"
                  :is-multiline="true"
                  :readonly="!canUserEdit"
                  content-property-name="text"
                />
                <v-select
                  v-if="
                    $store.state.mindestLohnKonfiguration.Configuration
                      .qualificationLevelEnabled
                  "
                  v-model="listItem.qualificationLevel"
                  :disabled="!canUserEdit"
                  :items="qualificationLevels"
                  class="ml-2"
                  placeholder="Qualifikationsstufe"
                  style="min-width: 316px"
                  text="text"
                  value="value"
                />
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-danger float-right actionButton"
                  placement="bottom"
                  title="Diesen Listeneintrag löschen"
                  type="button"
                  @click="removeListItem(criteria.listEntries, listItemIndex)"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
            </div>
            <div
              v-if="criteria.type == 10"
              class="row justify-content-end"
            >
              <div class="col-3">
                <v-select
                  v-model="criteriaToImportId"
                  :items="items"
                  item-text="title"
                  item-value="id"
                  label="Listeneintrag"
                />
              </div>

              <div>
                <b-button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="mt-2"
                  title="Listeneintrag impotieren"
                  variant="success"
                  @click="importListItem(criteria.listEntries)"
                >
                  <i class="fas fa-solid fa-file-import" />
                </b-button>
              </div>

              <div class="col-auto">
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-success actionButton mt-2"
                  title="Neuen Listeneintrag erfassen"
                  type="button"
                  @click="addNewListItem(criteria.listEntries)"
                >
                  <i class="fas fa-plus" />
                </button>
              </div>
            </div>
            <div
              v-if="criteria.type == 11"
              class="row"
            >
              <div class="col-2">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste der PLZ
                </label>
              </div>
              <div class="col-10">
                <u-tree-view
                  v-if="!isLoading"
                  id="cityDepTree"
                  v-model="criteria.criteriaPlzs"
                  :disabled="false"
                  :selectable="false"
                  :tree-view-items="
                    getTreeOptionsOfCriteria(criteria, citiesOptions)
                  "
                  item-key="path"
                >
                  <template v-slot:prepend="{ item }">
                    <div @click="togglePlzNode(item, index)">
                      <i
                        :class="getIcon(item, index)"
                        :style="{ scale: '1.8', color: getColor(item, index) }"
                      />
                    </div>
                  </template>
                </u-tree-view>
              </div>
            </div>
            <div
              v-if="criteria.type == 11"
              class="row"
            >
              <div class="col-12">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste
                </label>
              </div>
              <div
                v-for="(listItem, listItemIndex) in criteria.listEntries"
                :key="listItem.order + '_' + listItemIndex"
                class="col-12 d-flex"
              >
                <v-text-field
                  v-model="listItem.order"
                  :disabled="!canUserEdit"
                  class="col-1"
                  label="Sortierung"
                  type="number"
                >
                  <template
                    v-if="
                      criteria.listEntries.filter((item) => {
                        return item.order == listItem.order;
                      }).length > 1
                    "
                    slot="append"
                  >
                    <i
                      class="small"
                      style="color: red"
                    >Doppelte Sortierung</i>
                  </template>
                </v-text-field>
                <u-multiline-multilanguage-text-input
                  :id="'listItemValueInput' + listItemIndex"
                  v-model="listItem.contents"
                  :is-multiline="true"
                  :readonly="!canUserEdit"
                  content-property-name="text"
                />
                <v-select
                  v-if="
                    $store.state.mindestLohnKonfiguration.Configuration
                      .qualificationLevelEnabled
                  "
                  v-model="listItem.qualificationLevel"
                  :disabled="!canUserEdit"
                  :items="qualificationLevels"
                  class="ml-2"
                  placeholder="Qualifikationsstufe"
                  style="min-width: 316px"
                  text="text"
                  value="value"
                />
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-danger float-right actionButton"
                  placement="bottom"
                  title="Diesen Listeneintrag löschen"
                  type="button"
                  @click="removeListItem(criteria.listEntries, listItemIndex)"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
            </div>
            <div
              v-if="criteria.type == 11"
              class="row justify-content-end"
            >
              <div class="col-3">
                <v-select
                  v-model="criteriaToImportId"
                  :items="items"
                  item-text="title"
                  item-value="id"
                  label="Listeneintrag"
                />
              </div>

              <div>
                <b-button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="mt-2"
                  title="Listeneintrag impotieren"
                  variant="success"
                  @click="importListItem(criteria.listEntries)"
                >
                  <i class="fas fa-solid fa-file-import" />
                </b-button>
              </div>

              <div class="col-auto">
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-success actionButton mt-2"
                  title="Neuen Listeneintrag erfassen"
                  type="button"
                  @click="addNewListItem(criteria.listEntries)"
                >
                  <i class="fas fa-plus" />
                </button>
              </div>
            </div>
            <div
              v-if="
                criteria.type === 6 ||
                  criteria.type === 7 ||
                  criteria.type === 8 ||
                  criteria.type === 9 ||
                  criteria.type === 10 ||
                  criteria.type === 11
              "
              class="row"
            >
              <u-error-handling
                v-if="PlzErrorObject"
                :error-object="PlzErrorObject"
                class="col-12 mt-4"
              />
              <b-button
                v-if="canUserEdit"
                class="mt-2"
                name="saveStrucuture"
                variant="success"
                @click="saveCriteria(criteria)"
              >
                Speichern
              </b-button>
              <b-button
                v-if="canUserEdit"
                class="mt-2 ml-2"
                name="loadStructure"
                variant="danger"
                @click="getCriteria()"
              >
                Abbrechen
              </b-button>
            </div>
            <!-- 12 Gruppierte PLZ start -->
            <div v-if="criteria.type == 12">
              <u-error-handling
                v-if="ListerrorObject"
                :error-object="ListerrorObject"
                :property-mapping="listErrorPropertyMappings"
                class="col-12 mt-4"
              />
              <div class="col-12">
                <label class="font-weight-bold my-3 largeSectionTitle">
                  Liste
                </label>
              </div>
              <div
                v-for="(
                  groupedPlz, groupedPlzIndex
                ) in criteria.criteriaGroupedPlzs"
                :key="groupedPlz.order + '_' + groupedPlzIndex"
              >
                <div class="row">
                  <v-text-field
                    v-model="groupedPlz.listEntry.order"
                    :disabled="!canUserEdit"
                    class="col-1"
                    label="Sortierung"
                    type="number"
                  >
                    <template
                      v-if="
                        criteria.criteriaGroupedPlzs.filter((item) => {
                          return item.listEntry.order == groupedPlz.order;
                        }).length > 1
                      "
                      slot="append"
                    >
                      <i
                        class="small"
                        style="color: red"
                      >Doppelte Sortierung</i>
                    </template>
                  </v-text-field>
                  <u-multiline-multilanguage-text-input
                    :id="'listItemValueInput' + groupedPlzIndex"
                    v-model="groupedPlz.listEntry.contents"
                    :hide-languages="true"
                    :is-multiline="true"
                    :languages="
                      $store.state.mindestLohnKonfiguration
                        .BasicContractInformation.translatedLanguages
                    "
                    :readonly="!canUserEdit"
                    class="col-8"
                    content-property-name="text"
                  />
                  <v-select
                    v-if="
                      $store.state.mindestLohnKonfiguration.Configuration
                        .qualificationLevelEnabled
                    "
                    v-model="groupedPlz.listEntry.qualificationLevel"
                    :disabled="!canUserEdit"
                    :items="qualificationLevels"
                    class="col-2"
                    placeholder="Qualifikationsstufe"
                    text="text"
                    value="value"
                  />
                  <div class="col-1">
                    <button
                      class="btn btn-success actionButton"
                      placement="bottom"
                      title="Örtlicher Filter definieren"
                      type="button"
                      @click="toggleGroupedPlzFilterVisibility(groupedPlzIndex)"
                    >
                      <i class="fas fa-map-marker" />
                    </button>
                    <button
                      v-if="canUserEdit"
                      v-b-tooltip.hover
                      class="btn btn-danger actionButton"
                      placement="bottom"
                      title="Diesen Listeneintrag löschen"
                      type="button"
                      @click="
                        removeGroupedPlz(
                          criteria.criteriaGroupedPlzs,
                          groupedPlzIndex,
                        )
                      "
                    >
                      <i class="fas fa-trash-alt" />
                    </button>
                  </div>
                </div>
                <div
                  v-if="expandedGroupedPlzIndex == groupedPlzIndex"
                  class="row mt-2"
                >
                  <span class="col-1 mt-1">Örtlicher Filter</span>
                  <u-tree-view
                    v-if="!isLoading"
                    id="cityTree"
                    :disabled="false"
                    :selectable="true"
                    :tree-view-items="citiesOptions"
                    :value="groupedPlz.plzs"
                    class="ml-2 col-10"
                    item-key="path"
                    @input="
                      changeGroupedPlzSelection($event, index, groupedPlzIndex)
                    "
                  />
                </div>
                <v-divider v-if="expandedGroupedPlzIndex == groupedPlzIndex" />
              </div>
            </div>
            <div
              v-if="criteria.type == 12"
              class="row justify-content-end"
            >
              <div class="col-3">
                <v-select
                  v-model="criteriaToImportId"
                  :items="items"
                  item-text="title"
                  item-value="id"
                  label="Listeneintrag"
                />
              </div>

              <div>
                <b-button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="mt-2"
                  title="Listeneintrag importieren"
                  variant="success"
                  @click="
                    importGroupedPlzFromListItem(criteria.criteriaGroupedPlzs)
                  "
                >
                  <i class="fas fa-solid fa-file-import" />
                </b-button>
              </div>

              <div class="col-auto">
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-success actionButton mt-2"
                  title="Neue PLZ-Gruppierung erfassen"
                  type="button"
                  @click="addNewGroupedPlz(criteria.criteriaGroupedPlzs)"
                >
                  <i class="fas fa-plus" />
                </button>
              </div>
            </div>
            <div
              v-if="criteria.type == 12"
              class="row"
            >
              <criteria-grouped-plz-submit
                :criteria="
                  $store.state.mindestLohnKonfiguration.Criteria[index]
                "
                :disable-save="
                  !criteria.criteriaGroupedPlzs ||
                    criteria.criteriaGroupedPlzs.length == 0 ||
                    new Set(
                      criteria.criteriaGroupedPlzs.map((a) =>
                        a.listEntry.order.toString(),
                      ),
                    ).size < criteria.criteriaGroupedPlzs.length
                "
                @cancel="getCriteria()"
                @confirm="saveCriteria(criteria)"
              />
            </div>
            <!-- 12 Gruppierte PLZ end -->
          </form>
        </div>
      </div>
      <b-modal
        id="confirmDeleteListItem"
        ref="confirmDeleteListItem"
        class="w-100"
        hide-footer
        no-fade
        scrollable
        title="Eingabekriterium löschen"
      >
        <div class="d-block mb-4">
          Sind Sie sicher, dass Sie Dieses Eingabekriterium löschen möchten?
        </div>
        <b-button
          variant="success"
          @click="deleteCriteria()"
        >
          Ok
        </b-button>
        <b-button
          class="ml-2"
          variant="danger"
          @click="
            expandedId = -1;
            hideModal('confirmDeleteListItem');
          "
        >
          Abbrechen
        </b-button>
      </b-modal>
      <button
        v-if="
          items.filter((item) => {
            return item.id == 0;
          }).length > 0 && canUserEdit
        "
        v-b-tooltip.hover
        class="btn btn-success float-right actionButton mt-4"
        placement="bottom"
        title="Speichern sie zuerst neu erstellte Kriterien"
        type="button"
      >
        <i class="fas fa-plus" />
      </button>
      <button
        v-else-if="canUserEdit"
        v-b-tooltip.hover
        class="btn btn-success float-right actionButton my-4"
        placement="bottom"
        title="Neues Eingabekriterium hinzufügen"
        type="button"
        @click="addNewCriteria()"
      >
        <i class="fas fa-plus" />
      </button>
    </div>
  </div>
</template>

<script>
import {
  SaveCriteria,
  CreateCriteria,
  DeleteCriteria,
} from "@/services/minimum.wage.services/criteria.minimum.wages.js";
import { GetAllCantons, GetAllCities } from "@/services/cantons.service.js";
import { AggregatePlzArray } from "@/helpers/PlzHelper.js";
import {
  CreatedCountryMiloTreeView,
  RestrictLocationTreeViewToCantons,
  RestrictLocationTreeViewToDistricts,
  GetFlatTreeView,
} from "@/helpers/TreeViewHelper.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import CriteriaGroupsFilter from "@/components/minimum.wage/pages/CriteriaGroups/CriteriaGroupsFilter.vue";
import CriteriaGroupedPlzSubmit from "./CriteriaGroupedPlz/CriteriaGroupedPlzSubmit.vue";
import UTreeView from "@/components/common/UTreeView.vue";
import CriteriaList from "@/components/minimum.wage/pages/Criteria/CriteriaTypes/CriteriaList.vue";
import CriteriaAddLocalisedOrValues from "@/components/minimum.wage/pages/Criteria/CriteriaAddLocalisedOrValues.vue";

const VUEX_IDENTIFIER = "Criteria";

export default {
  components: {
    CriteriaGroupsFilter,
    CriteriaGroupedPlzSubmit,
    UTreeView,
    CriteriaList,
    CriteriaAddLocalisedOrValues,
  },
  mixins: [MinimumWageMixin],
  data() {
    return {
      ListerrorObject: null,
      RangeErrorObject: null,
      PlzErrorObject: null,
      criteriaToDelteIndex: -1,
      listErrorPropertyMappings: [],
      rangeErrorPropertyMappings: [],
      expandedId: -1,
      criteriaTypes: [
        { name: "Liste", id: 1 },
        { name: "Bereich", id: 2 },
        { name: "Dynamischer Bereich", id: 3 },
        { name: "Abhängige Liste", id: 4 },
        { name: "Kantonsliste", id: 6 },
        { name: "Bezirksliste", id: 7 },
        { name: "Postleitzahlliste", id: 8 },
        { name: "Abhängig von Kantonsliste", id: 9 },
        { name: "Abhängig von Bezirksliste", id: 10 },
        { name: "Abhängig von Postleitzahlliste", id: 11 },
        { name: "Gruppierte PLZ", id: 12 },
      ],
      allLanguages: [
        { name: "Deutsch", value: "de-CH" },
        { name: "Französisch", value: "fr-CH" },
        { name: "Italienisch", value: "it-CH" },
      ],
      operators: [
        { value: 1, name: "Equals", displayName: "gleich" },
        { value: 2, name: "GreaterThan", displayName: "grösser als" },
        { value: 3, name: "LessThan", displayName: "kleiner als" },
        {
          value: 4,
          name: "GreaterThanOrEqual",
          displayName: "gleich oder grösser als",
        },
        {
          value: 5,
          name: "LessThanOrEqual",
          displayName: "gleich oder kleiner als",
        },
        { value: 6, name: "Contains", displayName: "enthält" },
        { value: 7, name: "StartsWith", displayName: "beginnt mit" },
        { value: 8, name: "EndsWith", displayName: "endet mit" },
        { value: 9, name: "NotEquals", displayName: "ungleich" },
      ],
      qualificationLevels: [
        { value: 0, text: "0 - nicht relevant" },
        { value: 1, text: "1 - ungelernt" },
        { value: 2, text: "2 - angelernt" },
        { value: 3, text: "3 - gelernt (EFZ)" },
        { value: 4, text: "4 - Meister" },
        { value: 5, text: "5 - Kaderfunktion" },
        { value: 6, text: "6 - Vorarbeiter" },
        { value: 7, text: "7 - angelernt in artverwandtem Beruf" },
        { value: 8, text: "8 - gelernt in artverwandtem Beruf" },
        { value: 9, text: "9 - gelernt (EBA)" },
        { value: 10, text: "10 - Lehrling" },
      ],
      criteriaToImportId: null,
      expandedGroupedPlzIndex: -1,
      fullFlatLocationTree: [],
      criteriaToAddOrCandidatesIndex: 0,
    };
  },
  computed: {
    items: {
      get: function () {
        let itemsCopy = JSON.parse(
          JSON.stringify(this.$store.state.mindestLohnKonfiguration.Criteria),
        );
        itemsCopy.forEach((item) => {
          let existingPlz = [];

          if (item.criteriaPlzs && item.criteriaPlzs.length > 0) {
            item.criteriaPlzs.forEach((plz) => {
              existingPlz.push(plz.path ? plz.path : plz);
            });
            item.criteriaPlzs = existingPlz;
          }

          if (item.criteriaGroupedPlzs) {
            item.criteriaGroupedPlzs.forEach((groupedPlz) => {
              let existingPlz = [];
              if (groupedPlz.plzs) {
                groupedPlz.plzs.forEach((plz) => {
                  if (plz.path) {
                    existingPlz.push(plz.path);
                  }
                });
                groupedPlz.plzs = existingPlz;
              }
            });
          }
        });

        let criterias = this.$store.state.mindestLohnKonfiguration.Criteria;
        let plzCriterias = criterias.filter(
          (y) => y.criteriaPlzs && y.criteriaPlzs.length > 0,
        );
        let itemsToProcess = JSON.parse(JSON.stringify(itemsCopy));

        itemsToProcess.map((item) => {
          item.criteriaGroupFilters.map((group) => {
            let processedFilters = [];

            group.filters.map((filter) => {
              if (!plzCriterias.some((x) => x.id == filter.criteriaId)) {
                processedFilters.push(filter);
              } else {
                let existingPlzFilter = processedFilters.find(
                  (y) =>
                    y.criteriaId == filter.criteriaId &&
                    y.criteriaListEntryId == filter.criteriaListEntryId &&
                    y.criteriaStructureId == filter.criteriaStructureId &&
                    y.operator == filter.operator,
                );

                if (existingPlzFilter) {
                  existingPlzFilter.value += ";" + filter.value;
                } else {
                  processedFilters.push(filter);
                }
              }
            });

            group.filters = processedFilters;
          });
        });

        return itemsToProcess;
      },
      set: function (val) {
        let valCopy = JSON.parse(JSON.stringify(val));

        valCopy.forEach((crit) => {
          crit.listEntries.map((entry) => {
            if (entry.contents[0] && entry.contents[0].text) {
              entry.code = entry.contents[0].text;
            } else {
              entry.code = "";
            }
          });

          let plzDtos = [];
          if (crit.criteriaPlzs) {
            crit.criteriaPlzs.map((entry) => {
              let obj = {
                id: 0,
                criteriaId: crit.id,
                path: entry,
              };
              plzDtos.push(obj);
            });
          }
          crit.criteriaPlzs = plzDtos;

          if (crit.criteriaGroupedPlzs) {
            crit.criteriaGroupedPlzs.map((groupedPlz) => {
              if (
                groupedPlz.listEntry.contents[0] &&
                groupedPlz.listEntry.contents[0].text
              ) {
                groupedPlz.listEntry.code =
                  groupedPlz.listEntry.contents[0].text;
              } else {
                groupedPlz.listEntry.code = "";
              }

              let groupedPlzDtos = [];
              if (groupedPlz.plzs) {
                groupedPlz.plzs.map((entry) => {
                  let obj = {
                    Id: 0,
                    criteriaGroupedPlzId: groupedPlz.id,
                    path: entry,
                  };
                  groupedPlzDtos.push(obj);
                });
              }
              groupedPlz.plzs = groupedPlzDtos;
            });
          }
        });

        this.$store.commit("setCriteria", valCopy);
      },
    },
    flatCantonOptions() {
      return [
        this.cantonOptions[0],
        ...GetFlatTreeView(this.cantonOptions[0].children),
      ];
    },
    fullFlatCantonTree() {
      let completeTree = CreatedCountryMiloTreeView(
        this.$store.state.mindestLohnKonfiguration.Cities,
      );
      completeTree[0].children = RestrictLocationTreeViewToCantons(
        completeTree[0].children,
      );
      return [completeTree[0], ...GetFlatTreeView(completeTree[0].children)];
    },
    lowestLevelCanton() {
      return this.fullFlatCantonTree
        .map((x) => x.path.split("/").length)
        .reduce((a, b) => (a > b ? a : b));
    },
    flatDistrictOptions() {
      return [
        this.districtOptions[0],
        ...GetFlatTreeView(this.districtOptions[0].children),
      ];
    },
    fullFlatDistrictTree() {
      let completeTree = CreatedCountryMiloTreeView(
        this.$store.state.mindestLohnKonfiguration.Cities,
      );
      completeTree[0].children = RestrictLocationTreeViewToDistricts(
        completeTree[0].children,
      );
      return [completeTree[0], ...GetFlatTreeView(completeTree[0].children)];
    },
    lowestLevelDistrict() {
      return this.fullFlatDistrictTree
        .map((x) => x.path.split("/").length)
        .reduce((a, b) => (a > b ? a : b));
    },
    flatCitiesOptions() {
      return [
        this.citiesOptions[0],
        ...GetFlatTreeView(this.citiesOptions[0].children),
      ];
    },
    fullFlatCitiesTree() {
      let completeTree = CreatedCountryMiloTreeView(
        this.$store.state.mindestLohnKonfiguration.Cities,
      );
      return [completeTree[0], ...GetFlatTreeView(completeTree[0].children)];
    },
    lowestLevelCity() {
      return this.fullFlatCitiesTree
        .map((x) => x.path.split("/").length)
        .reduce((a, b) => (a > b ? a : b));
    },
    cantonOptions() {
      let locationsOfEdition =
        this.$store.state.mindestLohnKonfiguration.ValidEditionLocations;

      let citiesCopy = JSON.parse(
        JSON.stringify(this.$store.state.mindestLohnKonfiguration.Cities),
      );
      let topLevel = [
        {
          name: "CH",
          path: "CH",
          children: [],
          shutoff: false,
        },
      ];
      const cantonIdMap = new Map();
      for (const item of citiesCopy) {
        if (!cantonIdMap.has(item.cantonId)) {
          cantonIdMap.set(item.cantonId, true);
          if (locationsOfEdition.some((x) => x.cantonId == item.cantonId)) {
            topLevel[0].children.push({
              id: item.cantonId,
              name: `${item.canton} (${item.cantonCode})`,
              path: `CH/${item.cantonCode}`,
              children: [],
              shutoff: false,
            });
          }
        }
      }

      return topLevel;
    },
    districtOptions() {
      let locationsOfEdition =
        this.$store.state.mindestLohnKonfiguration.ValidEditionLocations;

      let citiesCopy = JSON.parse(
        JSON.stringify(this.$store.state.mindestLohnKonfiguration.Cities),
      );
      let topLevel = JSON.parse(JSON.stringify(this.cantonOptions));

      const districtCodeMap = new Map();
      for (const item of citiesCopy) {
        if (!districtCodeMap.has(item.districtCode)) {
          districtCodeMap.set(item.districtCode, true);
          let cantonOfDistrict = topLevel[0].children.find(
            (x) => x.path === `CH/${item.cantonCode}`,
          );
          if (
            locationsOfEdition.some(
              (x) =>
                x.cantonId == item.cantonId && x.districtId == item.districtId,
            )
          ) {
            cantonOfDistrict.children.push({
              id: item.districtId,
              name: item.district,
              districtCode: item.districtCode,
              path: `CH/${item.cantonCode}/${item.districtCode}`,
              children: [],
              shutoff: false,
            });
          }
        }
      }

      return topLevel;
    },
    citiesOptions() {
      let locationsOfEdition =
        this.$store.state.mindestLohnKonfiguration.ValidEditionLocations;

      let citiesCopy = JSON.parse(
        JSON.stringify(this.$store.state.mindestLohnKonfiguration.Cities),
      );
      let topLevel = JSON.parse(JSON.stringify(this.districtOptions));

      citiesCopy.map((item) => {
        let cantonOfCity = topLevel[0].children.find(
          (x) => x.path === `CH/${item.cantonCode}`,
        );
        if (cantonOfCity) {
          let districtOfCity = cantonOfCity.children.find(
            (x) => x.path === `CH/${item.cantonCode}/${item.districtCode}`,
          );
          if (
            locationsOfEdition.some(
              (x) =>
                x.cantonId == item.cantonId &&
                x.districtId == item.districtId &&
                x.cityId == item.cityId,
            )
          ) {
            item.name = `${item.plz} ${item.city}`;
            item.id = item.cityId;
            item.path = `CH/${item.cantonCode}/${item.districtCode}/${
              item.onrp
            }`;
            item.shutoff = false;
            districtOfCity.children.push(item);
          }
        }
      });

      return topLevel;
    },
    isLoading() {
      return this.$store.getters.isCriteriaLoading;
    },
    errorObject() {
      return this.$store.state.errorObjects.Criteria;
    },
  },
  created() {
    if (
      this.$store.state.mindestLohnKonfiguration.Cantons ||
      this.$store.state.mindestLohnKonfiguration.Cantons.length === 0
    ) {
      GetAllCantons(
        (response) => {
          this.$store.state.mindestLohnKonfiguration.Cantons = response;
        },
        (error) => {
          this.PlzErrorObject = error;
          this.stopLoading(VUEX_IDENTIFIER);
        },
      );
    }
    if (
      this.$store.state.mindestLohnKonfiguration.Cities ||
      this.$store.state.mindestLohnKonfiguration.Cities.length === 0
    ) {
      GetAllCities(
        (response) => {
          this.$store.state.mindestLohnKonfiguration.Cities = response;
        },
        (error) => {
          this.PlzErrorObject = error;
          this.stopLoading(VUEX_IDENTIFIER);
        },
      );
    }
    if (
      !this.$store.state.mindestLohnKonfiguration.ValidEditionLocations ||
      this.$store.state.mindestLohnKonfiguration.ValidEditionLocations
        .length === 0
    ) {
      if (this.$store.state.mindestLohnKonfiguration.Configuration.editionId) {
        this.$store.dispatch("getAllValidEditionLocations", {
          contractId: this.contractId,
          versionId: this.versionId,
          editionId:
            this.$store.state.mindestLohnKonfiguration.Configuration.editionId,
        });
      }
      this.$store.dispatch("getAllValidEditionLocations", {
        contractId: this.contractId,
        versionId: this.versionId,
        editionId:
          this.$store.state.mindestLohnKonfiguration.Configuration.editionId,
      });
    }
    this.getCriteria();
  },
  methods: {
    toggleGroupedPlzFilterVisibility(index) {
      this.expandedGroupedPlzIndex =
        this.expandedGroupedPlzIndex == index ? -1 : index;
    },
    changeGroupedPlzSelection(val, criteriaIndex, listItemIndex) {
      let itemsCopy = JSON.parse(JSON.stringify(this.items));
      itemsCopy[criteriaIndex].criteriaGroupedPlzs[listItemIndex].plzs = val;
      this.items = itemsCopy;
    },
    togglePlzNode(node, criteriaIndex) {
      let itemsCopy = JSON.parse(JSON.stringify(this.items));
      let selectedCriteria = itemsCopy[criteriaIndex];
      let criteriaType = itemsCopy[criteriaIndex].type;
      let selectedPlz = selectedCriteria.criteriaPlzs;
      if (node.children && node.children.length > 0) {
        let allChildren = [];
        let lowestLevel;

        if (criteriaType == 6 || criteriaType == 9) {
          allChildren = this.flatCantonOptions.filter(
            (x) => x.path.includes(node.path) && x.path != node.path,
          );
          lowestLevel = this.lowestLevelCanton;
          allChildren = allChildren.filter(
            (x) => x.path.split("/").length == lowestLevel,
          );
        }
        if (criteriaType == 7 || criteriaType == 10) {
          allChildren = this.flatDistrictOptions.filter(
            (x) => x.path.includes(node.path) && x.path != node.path,
          );
          lowestLevel = this.lowestLevelDistrict;
          allChildren = allChildren.filter(
            (x) => x.path.split("/").length == lowestLevel,
          );
        }
        if (criteriaType == 8 || criteriaType == 11) {
          allChildren = this.flatCitiesOptions.filter(
            (x) => x.path.includes(node.path) && x.path != node.path,
          );
          lowestLevel = this.lowestLevelCity;
          allChildren = allChildren.filter(
            (x) => x.path.split("/").length == lowestLevel,
          );
        }

        selectedPlz = selectedPlz.filter(
          (x) => x.split("/").length == lowestLevel,
        );

        let currentlySelectedChildren = selectedPlz.filter(
          (x) => x.includes(node.path) && x != node.path,
        );

        if (currentlySelectedChildren.length == allChildren.length) {
          itemsCopy[criteriaIndex].criteriaPlzs = selectedPlz.filter(
            (x) => !x.includes(node.path),
          );
          this.items = itemsCopy;
          return;
        }
        itemsCopy[criteriaIndex].criteriaPlzs = [
          ...selectedPlz.filter((x) => !x.includes(node.path)),
          ...allChildren
            .filter((x) => x.path.includes(node.path))
            .map((x) => x.path),
        ];
        this.items = itemsCopy;
        return;
      }
      if (selectedPlz && selectedPlz.length) {
        let lowestLevel = selectedPlz
          .map((x) => x.split("/").length)
          .reduce((a, b) => (a > b ? a : b));
        selectedPlz = selectedPlz.filter(
          (x) => x.split("/").length == lowestLevel,
        );
        if (selectedPlz.includes(node.path)) {
          itemsCopy[criteriaIndex].criteriaPlzs = selectedPlz.filter(
            (x) => x != node.path,
          );
          this.items = itemsCopy;
        } else {
          itemsCopy[criteriaIndex].criteriaPlzs = [...selectedPlz, node.path];
          this.items = itemsCopy;
        }
      } else {
        //Fallback if it has no childs & selectedplz
        if ("path" in node) {
          let selectedOption = [];

          if (criteriaType == 6 || criteriaType == 9) {
            selectedOption = this.flatCantonOptions.filter((x) =>
              x.path.includes(node.path),
            );
          }
          if (criteriaType == 7 || criteriaType == 10) {
            selectedOption = this.flatDistrictOptions.filter((x) =>
              x.path.includes(node.path),
            );
          }
          if (criteriaType == 8 || criteriaType == 11 || criteriaType == 12) {
            selectedOption = this.flatCitiesOptions.filter((x) =>
              x.path.includes(node.path),
            );
          }

          if (Array.isArray(itemsCopy[criteriaIndex].criteriaPlzs)) {
            itemsCopy[criteriaIndex].criteriaPlzs.push(selectedOption[0].path);
          } else {
            itemsCopy[criteriaIndex].criteriaPlzs = [];
            itemsCopy[criteriaIndex].criteriaPlzs.push(selectedOption[0].path);
          }

          this.items = itemsCopy;
        }
      }
    },
    getColor(node, criteriaIndex) {
      let selectedPlz = this.items[criteriaIndex].criteriaPlzs;
      let criteriaType = this.items[criteriaIndex].type;
      let lowestLevel;
      let fullTree;
      if (criteriaType == 6 || criteriaType == 9) {
        fullTree = this.fullFlatCantonTree;
        lowestLevel = this.lowestLevelCanton;
        selectedPlz = selectedPlz.filter(
          (x) => x.split("/").length == lowestLevel,
        );
      }
      if (criteriaType == 7 || criteriaType == 10) {
        fullTree = this.fullFlatDistrictTree;
        lowestLevel = this.lowestLevelDistrict;
        selectedPlz = selectedPlz.filter(
          (x) => x.split("/").length == lowestLevel,
        );
      }
      if (criteriaType == 8 || criteriaType == 11) {
        fullTree = this.fullFlatCitiesTree;
        lowestLevel = this.lowestLevelCity;
        selectedPlz = selectedPlz.filter(
          (x) => x.split("/").length == lowestLevel,
        );
      }

      if (selectedPlz.some((x) => x == node.path || x.includes(node.path))) {
        if (!node.children) {
          return "red";
        }

        selectedPlz = selectedPlz.filter(
          (x) => x.split("/").length == lowestLevel,
        );
        fullTree = fullTree.filter(
          (x) => x.path.split("/").length == lowestLevel,
        );
        if (
          selectedPlz.filter(
            (x) => x.includes(node.path) && x.path != node.path,
          ).length != fullTree.filter((x) => x.path.includes(node.path)).length
        ) {
          return "grey";
        }
        return "red";
      }
      return "grey";
    },
    getIcon(node, criteriaIndex) {
      let selectedPlz = this.items[criteriaIndex].criteriaPlzs;
      let criteriaType = this.items[criteriaIndex].type;
      let lowestLevel;
      let fullTree;
      if (criteriaType == 6 || criteriaType == 9) {
        fullTree = this.fullFlatCantonTree;
        lowestLevel = this.lowestLevelCanton;
      }
      if (criteriaType == 7 || criteriaType == 10) {
        fullTree = this.fullFlatDistrictTree;
        lowestLevel = this.lowestLevelDistrict;
      }
      if (criteriaType == 8 || criteriaType == 11) {
        fullTree = this.fullFlatCitiesTree;
        lowestLevel = this.lowestLevelCity;
      }
      if (selectedPlz.some((x) => x == node.path || x.includes(node.path))) {
        if (!node.children) {
          return "fas fa-check-square mr-1 ml-2 mt-1";
        }

        selectedPlz = selectedPlz.filter(
          (x) => x.split("/").length == lowestLevel,
        );
        fullTree = fullTree.filter(
          (x) => x.path.split("/").length == lowestLevel,
        );
        if (
          selectedPlz.filter(
            (x) => x.includes(node.path) && x.path != node.path,
          ).length != fullTree.filter((x) => x.path.includes(node.path)).length
        ) {
          return "fas fa-minus-square checkbox-minus mr-1 ml-2 mt-1";
        }
        return "fas fa-check-square mr-1 ml-2 mt-1";
      }

      return "fas fa-square mr-1 ml-2 mt-1";
    },
    getCurrentLanguagesContents() {
      let counter = 0;
      const contents = [];
      this.$store.state.mindestLohnKonfiguration.BasicContractInformation.translatedLanguages.forEach(
        (translatedLanguage) => {
          contents.push({
            id: 0,
            criteriaStructureId: 0,
            value: "",
            language: translatedLanguage.language,
          });
          counter++;
        },
      );

      if (
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .translatedLanguages.length == counter
      ) {
        return contents;
      }
    },
    getTreeOptionsOfCriteria(criteria, fullOptions) {
      let structureFlat = this.$store.state.mindestLohnKonfiguration.Structure;
      let parentCriteria;

      structureFlat.map((item) => {
        if (item.children.some((x) => x.id == criteria.criteriaStructureId)) {
          parentCriteria = this.items.find(
            (x) => x.criteriaStructureId == item.id,
          );
        }
      });

      let optionsCopy = [...fullOptions];
      let filteredOptions = [];

      if (
        !parentCriteria ||
        !parentCriteria.criteriaPlzs ||
        parentCriteria.criteriaPlzs.length == 0
      ) {
        return optionsCopy;
      }

      optionsCopy.map((canton) => {
        if (
          parentCriteria.criteriaPlzs.some((plz) =>
            plz.path
              ? plz.path.includes(canton.path)
              : plz.includes(canton.path),
          )
        ) {
          if (canton.children) {
            let districts = [];
            if (
              parentCriteria.criteriaPlzs.some((plz) =>
                plz.path ? plz.path == canton.path : plz == canton.path,
              )
            ) {
              districts = canton.children;
            } else {
              canton.children.map((district) => {
                if (
                  parentCriteria.criteriaPlzs.some((plz) =>
                    plz.path
                      ? plz.path.includes(district.path)
                      : plz.includes(district.path),
                  )
                ) {
                  if (district.children) {
                    let cities = [];
                    if (
                      parentCriteria.criteriaPlzs.some((plz) =>
                        plz.path
                          ? plz.path == district.path
                          : plz == district.path,
                      )
                    ) {
                      cities = district.children;
                    } else {
                      district.children.map((city) => {
                        if (
                          parentCriteria.criteriaPlzs.some((plz) =>
                            plz.path
                              ? plz.path.includes(city.path)
                              : plz.includes(city.path),
                          )
                        ) {
                          cities.push(city);
                        }
                      });
                      district.children = cities;
                    }
                  }
                  districts.push(district);
                }
              });
            }
            canton.children = districts;
          }
          filteredOptions.push(canton);
        }
      });
      return filteredOptions;
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
    hideModal(modalRef) {
      if (this.$refs[modalRef]) {
        this.$refs[modalRef].hide();
      }
    },
    addNewCriteria() {
      var newCriteria = {
        id: 0,
        title: "",
        type: 1,
        criteriaStructureId: 0,
        configurationId: 0,
        contents: [
          { id: 0, criteriaId: 0, value: "", language: "de-CH" },
          { id: 0, criteriaId: 0, value: "", language: "fr-CH" },
          { id: 0, criteriaId: 0, value: "", language: "it-CH" },
        ],
        listEntries: [],
        range: {
          id: 0,
          criteriaId: 0,
          from: "0",
          to: "0",
        },
        filters: [],
        criteriaGroupFilters: [],
        criteriaGroupedPlzs: [],
      };

      if (!this.items) {
        this.items = [];
      }
      this.items = [...this.items, newCriteria];
      this.expandedId = 0;
    },
    createListErrorPropertyMappings() {
      var mapping = {};

      for (let index = 0; index < 30; index++) {
        this.allLanguages.map((availableLanguage, lIndex) => {
          mapping[`ListEntries[${index}].Contents[${lIndex}].Text`] =
            `Listeneintrag ${index + 1} - ${
              availableLanguage.name + "e"
            } Beschreibung`;
        });
      }

      this.allLanguages.map((availableLanguage, lIndex) => {
        mapping[`Contents[${lIndex}].Value`] = `${
          availableLanguage.name
        } Anzeigename`;
      });

      return mapping;
    },
    createRangeErrorPropertyMappings() {
      var mapping = {};

      this.allLanguages.map((availableLanguage, lIndex) => {
        mapping[`Contents[${lIndex}].Value`] = `${
          availableLanguage.name
        } Anzeigename`;
      });

      return mapping;
    },
    criteriaTypeChanged() {
      //Clear Values that belong to type that isnt selected
      let itemsCopy = JSON.parse(JSON.stringify(this.items));
      itemsCopy.forEach((item) => {
        if (
          item.type !== 1 &&
          item.type !== 4 &&
          item.type !== 9 &&
          item.type !== 10 &&
          item.type !== 11
        ) {
          item.listEntries = [];
        }
        if (item.type !== 2 && item.type !== 3) {
          item.range = {
            id: 0,
            criteriaId: 0,
            from: "0",
            to: "0",
          };
        }
        if (item.type !== 4) {
          item.criteriaGroupFilters = [];
        }
        if (
          item.type != 6 &&
          item.type != 7 &&
          item.type != 8 &&
          item.type != 9 &&
          item.type != 10 &&
          item.type != 11
        ) {
          item.criteriaPlzs = [];
        }
        if (item.type != 12) {
          item.criteriaGroupedPlzs = [];
        }
      });

      this.items = itemsCopy;
    },
    deleteCriteria() {
      var itemToDelete = this.items[this.criteriaToDelteIndex];
      this.startLoading(VUEX_IDENTIFIER);

      if (itemToDelete) {
        if (itemToDelete.id == 0) {
          this.items.splice(this.criteriaToDelteIndex, 1);
          this.hideModal("confirmDeleteListItem");
          this.stopLoading(VUEX_IDENTIFIER);
        } else {
          DeleteCriteria(
            this.contractId,
            this.versionId,
            this.editionId,
            itemToDelete.id,
            () => {
              this.criteriaToDelteIndex = -1;
              this.hideModal("confirmDeleteListItem");
              this.getCriteria();
            },
            (error) => {
              this.stopLoading(VUEX_IDENTIFIER, error);
            },
          );
        }
      } else {
        this.stopLoading(VUEX_IDENTIFIER);
      }
    },
    deleteFilterGroup(collection, index) {
      collection.splice(index, 1);
      this.$store.commit("setCriteria", this.items);
    },
    removeListItem(collection, index) {
      collection.splice(index, 1);
      this.$store.commit("setCriteria", this.items);
    },
    removeGroupedPlz(collection, index) {
      collection.splice(index, 1);
      this.items = this.items;
    },
    addNewFilterGroup(criteria) {
      var newGroup = {
        id: 0,
        criteriaId: criteria.id,
        filters: [],
      };
      this.addNewFilterItem(newGroup.filters);
      criteria.criteriaGroupFilters.push(newGroup);
      this.$store.commit("setCriteria", this.items);
    },
    addNewFilterItem(list) {
      list.push({
        id: 0,
        operator: 1,
        criteriaStructureId: -1,
        value: "",
        order: 0,
      });
      this.$store.commit("setCriteria", this.items);
    },
    handleAddLocalisedOrValues(newFilterGroups){
      this.items[this.criteriaToAddOrCandidatesIndex].criteriaGroupFilters = [
        ...this.items[this.criteriaToAddOrCandidatesIndex].criteriaGroupFilters,
        ...newFilterGroups,
      ];
      this.$store.commit("setCriteria", this.items);
    },
    importGroupedPlzFromListItem(list) {
      if (this.criteriaToImportId) {
        let order = 10;
        let lastEntry = list.slice(-1).pop();
        if (lastEntry != undefined) {
          order = lastEntry.listEntry.order + 10;
        }

        let criteriaToImport = this.items.filter((item) => {
          return item.id == this.criteriaToImportId;
        });

        criteriaToImport[0].listEntries.forEach((listEntryImport) => {
          list.push({
            id: 0,
            plzs: [],
            listEntry: {
              id: 0,
              code: listEntryImport.code,
              contents: listEntryImport?.contents ? listEntryImport.contents.map((content) => {
                return {
                  id: 0,
                  criteriaStructureId: 0,
                  language: content.language,
                  text: content.text,
                };
              }) : [],
              order: order,
              qualificationLevel: listEntryImport.qualificationLevel,
            },
          });
          order += 10;
        });

        criteriaToImport[0].criteriaGroupedPlzs.forEach((groupedPlzImport) => {
          list.push({
            id: 0,
            plzs: groupedPlzImport.plzs,
            listEntry: {
              id: 0,
              code: groupedPlzImport.listEntry.code,
              contents: groupedPlzImport.listEntry?.contents ? groupedPlzImport.listEntry.contents.map((content) => {
                return {
                  id: 0,
                  criteriaStructureId: 0,
                  language: content.language,
                  text: content.text,
                };
              }) : [],
              order: order,
              qualificationLevel: groupedPlzImport.listEntry.qualificationLevel,
            },
          });
          order += 10;
        });

        this.items = this.items;
      }
    },
    handleImportListItem(criteriaToImportId, criteria) {
      this.criteriaToImportId = criteriaToImportId;
      this.importListItem(criteria.listEntries);
    },
    importListItem(list) {
      if (this.criteriaToImportId) {
        let order = 10;
        let lastEntry = list.slice(-1).pop();
        if (lastEntry != undefined) {
          order = lastEntry.order + 10;
        }

        let criteriaToImport = this.items.filter((item) => {
          return item.id == this.criteriaToImportId;
        });

        criteriaToImport[0].listEntries.forEach((listEntryImport) => {
          list.push({
            id: 0,
            criteriaId: 0,
            code: listEntryImport.code,
            contents: listEntryImport.contents ? listEntryImport.contents.map((content) => {
              return {
                id: 0,
                criteriaStructureId: 0,
                language: content.language,
                text: content.text,
              };
            }) : [],
            order: order,
            qualificationLevel: listEntryImport.qualificationLevel,
          });

          order += 10;
        });

        criteriaToImport[0].criteriaGroupedPlzs.forEach((groupedPlzImport) => {
          list.push({
            id: 0,
            criteriaId: 0,
            code: groupedPlzImport.listEntry.code,
            contents: groupedPlzImport.listEntry.contents ? groupedPlzImport.listEntry.contents.map((content) => {
              return {
                id: 0,
                criteriaStructureId: 0,
                language: content.language,
                text: content.text,
              };
            }) : [],
            order: order,
            qualificationLevel: groupedPlzImport.listEntry.qualificationLevel,
          });

          order += 10;
        });

        this.items = this.items;
      }
    },
    addNewListItem(list) {
      var order = 10;
      var lastEntry = list.slice(-1).pop();
      if (lastEntry != undefined) {
        order = lastEntry.order + 10;
      }

      list.push({
        id: 0,
        criteriaId: 0,
        code: "newListEntry",
        contents: this.getCurrentLanguagesContents(),
        order: order,
      });
      this.$store.commit("setCriteria", this.items);
    },
    addNewGroupedPlz(list) {
      var order = 10;
      var lastEntry = list.slice(-1).pop();
      if (lastEntry) {
        order = lastEntry.listEntry.order + 10;
      }

      list.push({
        id: 0,
        listEntry: {
          id: 0,
          criteriaGroupedPlzId: 0,
          code: "newListEntry",
          contents: this.getCurrentLanguagesContents(),
          order: order,
        },
        plzs: [],
      });
      this.items = this.items;
    },
    getCriteria() {
      this.$store.dispatch("getCriteria", {
        contractId: this.contractId,
        versionId: this.versionId,
        editionId: this.editionId,
      });
    },
    saveCriteria(criteriaToSave) {
      this.ListerrorObject = null;
      this.RangeErrorObject = null;
      let allCriterias = this.$store.state.mindestLohnKonfiguration.Criteria;
      let plzCriterias = allCriterias.filter(
        (y) => y.criteriaPlzs && y.criteriaPlzs.length > 0,
      );
      this.listErrorPropertyMappings = this.createListErrorPropertyMappings();
      this.rangeErrorPropertyMappings = this.createRangeErrorPropertyMappings();

      this.startLoading(VUEX_IDENTIFIER);
      criteriaToSave = JSON.parse(JSON.stringify(criteriaToSave));

      if (criteriaToSave.type == 4) {
        criteriaToSave.criteriaGroupFilters.map((group) => {
          let groupFilters = [];
          group.filters.map((filter) => {
            if (!plzCriterias.some((x) => x.id == filter.criteriaId)) {
              groupFilters.push(filter);
            } else {
              let paths = filter.value.split(";");
              paths.forEach((path) => {
                groupFilters.push({
                  ...filter,
                  value: path,
                  id: 0,
                });
              });
            }
          });

          group.filters = groupFilters;
        });
      }

      criteriaToSave.listEntries.map((entry) => {
        let contentForCode = entry.contents.find((x) => x.language == "de-CH");
        if (!contentForCode) {
          contentForCode = entry.contents.find((x) => x.language == "fr-CH");
        }
        if (!contentForCode) {
          contentForCode = entry.contents.find((x) => x.language == "it-CH");
        }

        if (contentForCode && contentForCode.text) {
          entry.code = contentForCode.text;
        } else {
          entry.code = "";
        }
      });

      let plzDtos = [];
      if (criteriaToSave.criteriaPlzs) {
        criteriaToSave.criteriaPlzs.map((entry) => {
          let obj = {
            id: 0,
            criteriaId: criteriaToSave.id,
            path: entry,
          };
          plzDtos.push(obj);
        });
      }

      let aggregatedPlzs = AggregatePlzArray(
        plzDtos,
        CreatedCountryMiloTreeView(
          this.$store.state.mindestLohnKonfiguration.Cities,
        ),
      );
      criteriaToSave.criteriaPlzs = aggregatedPlzs;

      if (criteriaToSave.type == 12) {
        criteriaToSave.criteriaGroupedPlzs.map((group) => {
          let groupedPlzDtos = [];
          if (group.plzs) {
            group.plzs.map((entry) => {
              let obj = {
                Id: 0,
                criteriaGroupedPlzId: group.id,
                path: entry,
              };
              groupedPlzDtos.push(obj);
            });
          }
          if (group.listEntry) {
            let contentForCode = group.listEntry.contents.find(
              (x) => x.language == "de-CH",
            );
            if (!contentForCode) {
              contentForCode = group.listEntry.contents.find(
                (x) => x.language == "fr-CH",
              );
            }
            if (!contentForCode) {
              contentForCode = group.listEntry.contents.find(
                (x) => x.language == "it-CH",
              );
            }

            if (contentForCode && contentForCode.text) {
              group.listEntry.code = contentForCode.text;
            } else {
              group.listEntry.code = "";
            }
          }

          let groupAggregatedPlzs = AggregatePlzArray(
            groupedPlzDtos,
            this.citiesOptions,
          );
          group.plzs = groupAggregatedPlzs;
          return group;
        });
      }

      if (criteriaToSave.id == 0) {
        CreateCriteria(
          this.contractId,
          this.versionId,
          this.editionId,
          criteriaToSave,
          () => {
            this.getCriteria();
          },
          (error) => {
            this.ListerrorObject = error;
            this.RangeErrorObject = error;
            this.PlzErrorObject = error;
            this.stopLoading(VUEX_IDENTIFIER);
          },
        );
      } else {
        SaveCriteria(
          this.contractId,
          this.versionId,
          this.editionId,
          criteriaToSave,
          () => {
            this.getCriteria();
          },
          (error) => {
            this.stopLoading(VUEX_IDENTIFIER);
            this.ListerrorObject = error;
            this.RangeErrorObject = error;
            this.PlzErrorObject = error;
          },
        );
      }
    },
  },
};
</script>

<style scoped>
.or-label {
  font-weight: bold;
  margin: 10px 10px;
  font-size: 1.3rem;
}

.grouped-filters {
  border: 1px solid rgb(160, 160, 160);
  padding: 15px 0px 20px;
  margin-left: 5px;
  width: calc(100% - 10px);
  position: relative;
}

.group-title {
  color: gray;
  position: absolute;
  top: -12px;
  left: 20px;
  background-color: white;
  padding: 0px 10px;
}

.largeSectionTitle {
  font-size: 1.4rem;
}

.actionButton {
  height: 34px;
  margin-top: 15px;
  margin-left: 10px;
}

.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}

.deleteFilterActionButton {
  height: 34px;
  margin-top: 15px;
  margin-left: 3px;
}

.configurationWrapper {
  border-bottom: 1px solid rgb(59, 59, 59);
}

.criterionTitle {
  font-size: 1.2rem;
  cursor: pointer;
  font-weight: bold;
  border-bottom: 1px solid rgb(235, 235, 235);
  padding: 7px;
}

.width20 {
  width: 20px;
}

.criteriaContent {
  overflow: scroll;
  max-height: 3500px;
}

.accordion-enter-active {
  transition: 1s;
}

.accordion-leave-active {
  transition: 0.2s;
}

.accordion-enter {
  max-height: 0px;
}

.accordion-leave-to {
  max-height: 0px;
}

.verticalAlignCenter {
  line-height: 57px;
}

.deleteCriteriaButton {
  position: absolute;
  right: 10px;
  top: 6px;
  width: 30px;
  height: 30px;
  padding: 0;
}

.error-message {
    white-space: pre-line;
}
</style>
